import { render, staticRenderFns } from "./AppGlobalHeader.vue?vue&type=template&id=76795e30&"
import script from "./AppGlobalHeader.vue?vue&type=script&lang=ts&"
export * from "./AppGlobalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports